module.exports = __webpack_public_path__ + "static/media/color0.91e4a51c.PNG";